/**
 * Utility functions for lesson configuration
 */

/**
 * Normalizes lesson numbers to ensure consistent comparison
 * Handles both "01" and "001" formats by padding to 3 digits
 *
 * @param {string|number} lessonNumber - The lesson number to normalize
 * @returns {string} - The normalized lesson number (e.g., "001")
 */
export const normalizeLessonNumber = (lessonNumber) => {
  if (!lessonNumber) return null;
  return String(lessonNumber).padStart(3, '0');
};

/**
 * Compares two lesson numbers for equality, handling different formats
 *
 * @param {string|number} a - First lesson number
 * @param {string|number} b - Second lesson number
 * @returns {boolean} - True if the lesson numbers are equal
 */
export const lessonNumbersEqual = (a, b) => {
  return normalizeLessonNumber(a) === normalizeLessonNumber(b);
};
